import { State } from '../Store';

export const selectCustomerServices = (state: State) => state.customerServices;

export const selectCustomerServicesById = (customerId: number) => (
  state: State
) => selectCustomerServices(state)[customerId];
